import React from "react";
import { motion } from "framer-motion";

const SectionTitle = ({ overline, title, sub, align = "left", testId }) => {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div
      data-testid={testId}
      className={`max-w-3xl ${align === "center" ? "mx-auto" : ""} mb-14 md:mb-20`}
    >
      {overline && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.6 }}
          className={`overline kw-accent-line ${alignClass}`}
        >
          {overline}
        </motion.p>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className={`font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F2EBE5] mt-6 leading-[1.05] ${alignClass}`}
      >
        {title}
      </motion.h2>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className={`mt-6 text-base md:text-lg text-[#A19E9C] max-w-2xl ${alignClass} leading-relaxed`}
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
};

export default SectionTitle;
